import type { AnalyticsScreen } from "./contract";
const routes: Record<string, AnalyticsScreen> = {
  "/trips": "trips",
  "/trips/new": "trip_create",
  "/trips/:id": "trip",
  "/trip/:id": "trip",
  "/trips/:id/summary": "trip_summary",
  "/trips/:id/details": "trip_details",
  "/trips/:id/events/:id": "trip_events",
  "/trips/:id/costs/:id": "trip_costs",
  "/trips/:id/attachments": "trip_attachments",
  "/trips/:id/travellers": "trip_travellers",
  "/packing-lists": "packing_lists",
  "/packing-lists/new": "packing_list_create",
  "/packing-lists/:id": "packing_list",
  "/countries": "countries",
  "/country/:id": "country",
  "/travel-bucket-list": "bucket_list",
  "/statistics": "statistics",
  "/translate": "translate",
  "/settings": "settings",
  "/settings/subscription": "subscription",
  "/settings/plans": "plans",
  "/plans": "plans",
  "/profile": "profile",
  "/onboarding": "onboarding",
};
/** Accept router-defined templates only. Never pass pathname, URL, params or titles. */
export function analyticsScreen(template: string): AnalyticsScreen | null {
  let route: string;
  if (template.startsWith("/_authenticated/_protected/"))
    route = template.slice("/_authenticated/_protected".length);
  else if (template.startsWith("/(protected)/"))
    route = template.slice("/(protected)".length);
  else return null;
  if (/[?#\\]|\/\/|%/.test(route)) return null;
  route = route
    .replace(
      /\/(?:\$[a-zA-Z][a-zA-Z0-9_]*|\[[a-zA-Z][a-zA-Z0-9_]*\])(?=\/|$)/g,
      "/:id",
    )
    .replace(/\/index$/, "")
    .replace(/\/$/, "");
  return Object.hasOwn(routes, route) ? (routes[route] ?? null) : null;
}
